import { decryptObject } from "../components/GlobalFunction";
import ApiProvider from "./ApiProvider";

export class ApiCore {
  getSessionData() {
    const raw = sessionStorage.getItem("sessioninfo");
    return raw ? decryptObject(raw) : null;
  }

  post(url, body) {
    return ApiProvider.post(url, body);
  }

  postAuth(url, body) {
    const sessionData = this.getSessionData();
    if (!sessionData) throw new Error("No session found. Please login again.");

    let options1 = {
      headers: {
        Authorization: "Bearer " + sessionData.accessToken,
        "Content-Type": "application/json",
        empId: sessionData.employee_id,
      },
    };
    return ApiProvider.post(url, body, options1);
  }

  get(url) {
    return ApiProvider.get(url, {
      headers: { "Content-Type": "application/json" },
    });
  }

  getAuth(url) {
    const sessionData = this.getSessionData();
    if (!sessionData) throw new Error("No session found. Please login again.");

    let options1 = {
      headers: {
        Authorization: "Bearer " + sessionData.accessToken,
        "Content-Type": "application/json",
        empId: sessionData.employee_id,
      },
    };
    return ApiProvider.get(url, options1);
  }

  // Binary file downloads (e.g. a generated report's .xlsx) -- same auth
  // headers as postAuth, but with responseType "blob" so axios doesn't
  // try to parse the response body as JSON.
  postAuthBlob(url, body) {
    const sessionData = this.getSessionData();
    if (!sessionData) throw new Error("No session found. Please login again.");

    let options1 = {
      headers: {
        Authorization: "Bearer " + sessionData.accessToken,
        "Content-Type": "application/json",
        empId: sessionData.employee_id,
      },
      responseType: "blob",
    };
    return ApiProvider.post(url, body, options1);
  }

  postforFormData(url, formdata) {
    const sessionData = this.getSessionData();
    if (!sessionData) throw new Error("No session found. Please login again.");

    let options1 = {
      headers: {
        Authorization: "Bearer " + sessionData.accessToken,

        empId: sessionData.employee_id,
      },
    };
    return ApiProvider.post(url, formdata, options1);
  }

  // Multipart upload (file + form fields) that downloads a binary file
  // back -- same no-explicit-Content-Type rule as postforFormData (so the
  // browser sets the multipart boundary), combined with responseType
  // "blob" from postAuthBlob, for endpoints like MCL generation that take
  // an uploaded Excel file and return a generated file.
  postFormDataBlob(url, formdata) {
    const sessionData = this.getSessionData();
    if (!sessionData) throw new Error("No session found. Please login again.");

    let options1 = {
      headers: {
        Authorization: "Bearer " + sessionData.accessToken,
        empId: sessionData.employee_id,
      },
      responseType: "blob",
    };
    return ApiProvider.post(url, formdata, options1);
  }
}
